import { render, staticRenderFns } from "./ReserveReceptionQuick.vue?vue&type=template&id=51b8bec6&scoped=true"
import script from "./ReserveReceptionQuick.vue?vue&type=script&lang=js"
export * from "./ReserveReceptionQuick.vue?vue&type=script&lang=js"
import style0 from "./ReserveReceptionQuick.vue?vue&type=style&index=0&id=51b8bec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8bec6",
  null
  
)

export default component.exports